import { fetch as r } from "./index32.js";
function a() {
  function t(e, n) {
    return r(e, {
      headers: { "Content-Type": "text/plain" },
      method: "post",
      body: JSON.stringify(n)
    });
  }
  return {
    dispatch: t
  };
}
export {
  a as default
};
//# sourceMappingURL=index53.js.map
